import Navbar from '../../components/NavBar'

const ComponentsPage = () => {
  return (
    <>
      Components Page
      <Navbar />
    </>
  )
}

export default ComponentsPage
